import { Store } from 'redux';
//import createFulogicsStore, { DefaultReducers } from "fulogics-mobile-core/src/redux/configureStore";
import { persistStore, Persistor } from 'redux-persist';
import { store } from './store/store';
import translation_pl from './translations/locales/pl.json';
//import {addFontAwesomeIcons, initDevexpressPL, setWebStorage} from "fulogics-ui-web";
import { locale } from 'devextreme/localization';
import config from 'devextreme/core/config';
import LoadIndicator from 'devextreme/ui/load_indicator';
import loadingIndicator from './layout/assets/loader.gif';
import LoadPanel from 'devextreme/ui/load_panel';
import { initDevexpressPL } from 'fulogics-ui-web/dist/translations/locales/devexpress-pl';
import { setWebStorage } from 'fulogics-ui-web/dist/security/tokenStorageImplementation';
import { Singleton } from 'fulogics-ui-core/dist/Singleton';
import { createApiClient } from 'fulogics-ui-core/dist/api/apiClient';
import { setTokenStorage } from 'fulogics-ui-core/dist/security/tokenStorage';
import configuration from 'fulogics-ui-web/dist/configuration';
import { addFontAwesomeIcons } from 'fulogics-ui-web/dist/web/fontAwesome';
import { seti18next } from 'fulogics-ui-web/dist/translations/seti18next';
import toast from 'fulogics-ui-web/dist/utils/toast';
import moment from 'moment';
import 'moment/locale/pl';

export interface InitResult {
    store: Store;
    persistor: Persistor;
}

export function initLanguage() {
    /*
    seti18next({
        pl: {
            translation: translation_pl
        },
    });
     */
    initDevexpressPL();

    locale('pl');
    config({
        defaultCurrency: 'PLN'
    });
    moment.locale('pl')
}

export function init(): InitResult {
    // Initialization :
    setWebStorage();
    //
    Singleton.getInstance().apiClient = createApiClient();
    Singleton.getInstance().toast = toast;

    // -- Store :
    let persistor = persistStore(store);

    // -- Language :
    initLanguage();

    // -- Layout :
    LoadIndicator.defaultOptions({
        options: {
            indicatorSrc: loadingIndicator,
        },
    });
    LoadPanel.defaultOptions({
        options: {
            indicatorSrc: loadingIndicator,
        },
    });
    //
    addFontAwesomeIcons();
    //
    return { store, persistor };
}
